/*
  Orientierung auf langen Guide-Seiten
  ===================================

  Ein PDF gibt drei Dinge gratis her: Man sieht, wie dick es ist, man weiss, wo
  man gerade ist, und vorne steht ein Inhaltsverzeichnis. Auf einer Webseite
  faellt das alles weg — der Text wirkt wie ein Fluss ohne erkennbares Ende.

  Dieses Skript baut die drei Dinge nach:

    1. Kopfzeile mit Lesezeit und Kapitelanzahl
    2. Inhaltsverzeichnis mit Sprungmarken
    3. Fortschrittsbalken am oberen Rand
    4. Kapitelnummern ("3 von 8") in den Ueberschriften

  Es greift nur, wenn eine Seite mindestens drei <h2> mit id hat. Damit schaltet
  es sich bei kurzen Seiten von selbst ab und bei jedem kuenftigen Guide von
  selbst an, ohne dass jemand etwas eintragen muss.

  Ohne JavaScript bleibt die Seite vollstaendig lesbar — es kommt nur nichts
  hinzu.
*/
(function () {
  'use strict';

  var WOERTER_PRO_MINUTE = 200; // ruhiges Lesetempo bei Sachtexten

  /* Bilder vor dem Drucken vollstaendig laden.
     ------------------------------------------
     Bilder mit loading="lazy" laedt der Browser erst, wenn sie in die Naehe des
     Bildschirms kommen. Wer oben auf „Als PDF speichern“ klickt, hat die
     meisten also nie gesehen — und im PDF fehlten sie dann, waehrend die
     Bildunterschrift stehen blieb. Genau so war das Bild „Hülsenfrüchte sind
     als Hauptproteinquelle nicht ideal“ im Ausdruck verschwunden.

     Deshalb: erst alle auf sofort laden umstellen, warten, dann drucken. Der
     Zeitdeckel verhindert, dass ein haengendes Bild den Druck blockiert. */
  function alleBilderLaden(fertig) {
    var bilder = Array.prototype.slice.call(document.querySelectorAll('img'));
    var offen = 0;
    var abgeschlossen = false;

    function fertigMelden() {
      if (abgeschlossen) return;
      abgeschlossen = true;
      fertig();
    }

    bilder.forEach(function (bild) {
      bild.loading = 'eager';
      if (bild.complete && bild.naturalWidth > 0) return;
      offen++;
      var abhaken = function () {
        offen--;
        if (offen === 0) fertigMelden();
      };
      bild.addEventListener('load', abhaken, { once: true });
      bild.addEventListener('error', abhaken, { once: true });
    });

    if (offen === 0) fertigMelden();
    else setTimeout(fertigMelden, 8000);
  }

  /* Kurze Adresse fuer den Ausdruck.
     -------------------------------
     Die Adresse im Ausdruck hat genau einen Zweck: Wer das Blatt in der Hand
     haelt, soll das Ziel erreichen koennen. Deshalb wird sie nur gedruckt,
     wenn man mit ihr tatsaechlich dort ankommt.

     Vorher stand hinter jedem der 82 Produktlinks des Einkaufsguides
     „(amazon.de)“ — die Domain eines abgeschnittenen Affiliate-Links, mit der
     man auf der Startseite landet, nicht beim Produkt. Bei den Gewuerzen las
     sich eine Zeile dadurch als „Salz (amazon.de), Pfeffer, Knoblauchpulver
     (amazon.de), Zwiebelpulver (amazon.de)“.

     Gibt null zurueck, wenn die Adresse nichts nuetzt. */
  function kurzeAdresse(adresse) {
    var a;
    try {
      a = new URL(adresse);
    } catch (e) {
      return null;
    }
    var host = a.hostname.replace(/^www\./, '');
    var pfad = a.pathname.replace(/\/$/, '');
    // Startseite: die Domain allein ist das Ziel.
    if (!pfad) return host;
    // Kurzer, sprechender Pfad ohne Parameter — z. B. instagram.com/name.
    if (pfad.length <= 25 && !a.search) return host + pfad;
    // Alles andere muesste gekuerzt werden und fuehrt dann ins Leere.
    return null;
  }

  /* Nennt der Linktext die Adresse schon, waere sie doppelt: „Nutri-Plus.De
     (nutri-plus.de)“, „Datteldealer (datteldealer.de)“, „Veeze (veeze.de)“. */
  function adresseStehtSchonImText(a, kurz) {
    // Beide Seiten auf Buchstaben und Ziffern reduzieren: „Nutri-Plus.De“ und
    // „nutri-plus.de“ sind dasselbe, unterscheiden sich aber im Bindestrich.
    var nurZeichen = function (s) { return s.toLowerCase().replace(/[^a-z0-9]/g, ''); };
    var text = nurZeichen(a.textContent || '');
    var kern = nurZeichen(kurz.split('/')[0].split('.')[0]);
    return kern.length > 3 && text.indexOf(kern) !== -1;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var inhalt = document.querySelector('.main-page-title')
      ? document.querySelector('.main-page-title').parentElement.querySelector('.rte')
      : document.querySelector('.rte');
    if (!inhalt) return;

    /* ---- Tabellen fuer schmale Bildschirme einpacken ----
       Eine Tabelle mit vier Spalten sprengt auf dem Telefon die Seite: Der
       ganze Text wird dann waagerecht scrollbar, nicht nur die Tabelle.
       Deshalb bekommt jede ein eigenes Behaeltnis, das fuer sich scrollt.
       Im Ausdruck hebt das Druck-CSS die Begrenzung wieder auf. */
    Array.prototype.forEach.call(inhalt.querySelectorAll('table'), function (tabelle) {
      if (tabelle.parentElement && tabelle.parentElement.classList.contains('guide-tabelle')) return;
      var huelle = document.createElement('div');
      huelle.className = 'guide-tabelle';
      huelle.setAttribute('role', 'region');
      huelle.setAttribute('tabindex', '0');
      huelle.setAttribute('aria-label', 'Tabelle, waagerecht scrollbar');
      tabelle.parentNode.insertBefore(huelle, tabelle);
      huelle.appendChild(tabelle);
    });

    /* ---- Einkaufsliste abhaken ----
       Die Liste heisst „zum Abhaken“ und wird im Laden benutzt. Ein Tippen
       setzt den Haken, ein zweites nimmt ihn zurueck. Der Zustand wird nicht
       gespeichert: Sonst startet der naechste Einkauf mit den Haken vom
       letzten, und das faellt erst auf, wenn man vor dem Regal steht.

       Die Punkte bekommen tabindex und eine Rolle, damit sie auch ohne Maus
       bedienbar sind und Screenreader ansagen, was sie sind.

       Steht bewusst vor der Kapitelpruefung weiter unten: Die Navigation
       schaltet sich unter drei Kapiteln ab, das Abhaken soll auch auf einer
       kurzen Liste funktionieren. Findet sich keine Abhakliste, kostet die
       Schleife nichts. */
    Array.prototype.forEach.call(
      inhalt.querySelectorAll('.guide-abhaken > li'),
      function (punkt) {
        punkt.setAttribute('role', 'checkbox');
        punkt.setAttribute('aria-checked', 'false');
        punkt.setAttribute('tabindex', '0');

        var umschalten = function () {
          var an = punkt.classList.toggle('ist-abgehakt');
          punkt.setAttribute('aria-checked', an ? 'true' : 'false');
        };

        punkt.addEventListener('click', function (e) {
          // Ein Link im Punkt soll den Link oeffnen, nicht abhaken.
          if (e.target.closest('a')) return;
          umschalten();
        });

        punkt.addEventListener('keydown', function (e) {
          if (e.key !== ' ' && e.key !== 'Enter') return;
          if (e.target.closest('a')) return;
          e.preventDefault();
          umschalten();
        });
      }
    );

    var kapitel = Array.prototype.filter.call(
      inhalt.querySelectorAll('h2'),
      function (h) { return h.id; }
    );
    if (kapitel.length < 3) return;

    /* ---- Werbe-Einblendung wie im PDF-Betrachter ----
       Die PDF-Fassungen blenden nach 30, 60 und 120 Sekunden eine Karte mit
       dem Nutri-Plus-Rabatt ein; darueber finanziert sich die Arbeit an den
       Guides mit. Auf den Webseiten fehlte das bisher, weil die vorhandene
       Mechanik in custom-popup.js am PDF-Modal haengt.

       Die Vorlagen liefert snippets/guide-werbung.liquid, die Zeiten kommen
       aus den Theme-Einstellungen. Gezeigt wird jede Karte einmal; wer sie
       schliesst, bekommt sie nicht noch einmal, die naechste aber schon —
       genau wie im PDF.

       Steht bewusst NACH der Kapitelpruefung: main-page.liquid gilt fuer
       jede Seite mit Seiten-Vorlage, also auch fuer Impressum, Datenschutz
       und Versandbedingungen. Dort hat Werbung nichts zu suchen. Auf
       Seiten mit mindestens drei Kapiteln — den Guides — schon.

       Rechtstexte schliesst guide-werbung.liquid zusaetzlich ausdruecklich
       aus: Die Datenschutzerklaerung des Vegan Buddy hat zehn Kapitel und
       waere sonst durch diese Pruefung gefallen. */

    /* ---- Wie oft darf eine Karte kommen? ----
       Bis August 2026 zaehlte nur der einzelne Seitenaufruf: Wer sich durch
       zehn FAQ-Antworten las, bekam zehnmal von vorn drei Karten. Der Zaehler
       steht deshalb jetzt im localStorage und gilt fuer den ganzen Shop.

       Drei Grenzen zugleich, alle in den Theme-Einstellungen:
         - hoechstzahl:    wie viele Karten insgesamt, bevor Ruhe ist
         - mindestabstand: Minuten zwischen zwei Karten, seitenuebergreifend
         - ruhetage:       nach welcher Zeit der Zaehler wieder bei null steht

       Der Mindestabstand gilt bewusst nur ZWISCHEN Seiten, nicht innerhalb
       einer. Sonst haette er die spaeteren Zeitpunkte aufgefressen: Bei 20
       Minuten Abstand und Karten nach 90, 300 und 600 Sekunden waeren die
       zweite und dritte nie erschienen, und zwei der drei Einstellungen waeren
       tote Regler gewesen. Auf einer Seite entscheiden also die Zeitpunkte,
       beim Wechsel auf die naechste der Abstand.

       Faellt localStorage aus (privates Fenster, gesperrte Speicherung),
       greift der Stand nur fuer diesen Seitenaufruf — dann verhaelt es sich
       wie vorher, statt gar nicht zu erscheinen. */
    var SPEICHER = 'nvsino_werbung';
    var behaelter = document.querySelector('.guide-werbung-vorlagen');
    var hoechstzahl = parseInt((behaelter && behaelter.getAttribute('data-hoechstzahl')) || '3', 10);
    var abstandMs = parseInt((behaelter && behaelter.getAttribute('data-mindestabstand-min')) || '20', 10) * 60000;
    var ruheMs = parseInt((behaelter && behaelter.getAttribute('data-ruhetage')) || '14', 10) * 86400000;
    var ersatzstand = null;      // falls localStorage nicht verfuegbar ist
    var schonAufDieserSeite = false;

    function standLesen() {
      try {
        var roh = window.localStorage.getItem(SPEICHER);
        if (!roh) return { anzahl: 0, zuletzt: 0 };
        var stand = JSON.parse(roh);
        // Nach der Ruhezeit faengt die Zaehlung wieder bei null an.
        if (ruheMs > 0 && stand.zuletzt && Date.now() - stand.zuletzt > ruheMs) {
          return { anzahl: 0, zuletzt: 0 };
        }
        return { anzahl: stand.anzahl || 0, zuletzt: stand.zuletzt || 0 };
      } catch (e) {
        return ersatzstand || { anzahl: 0, zuletzt: 0 };
      }
    }

    function standSchreiben(stand) {
      ersatzstand = stand;
      try { window.localStorage.setItem(SPEICHER, JSON.stringify(stand)); } catch (e) {}
    }

    function darfErscheinen() {
      var stand = standLesen();
      if (hoechstzahl > 0 && stand.anzahl >= hoechstzahl) return false;
      if (schonAufDieserSeite) return true;
      if (abstandMs > 0 && stand.zuletzt && Date.now() - stand.zuletzt < abstandMs) return false;
      return true;
    }

    Array.prototype.forEach.call(
      document.querySelectorAll('.guide-werbung-vorlage'),
      function (vorlage) {
        var verzoegerung = parseInt(vorlage.getAttribute('data-verzoegerung-ms') || '0', 10);
        if (!(verzoegerung > 0)) return;

        var versuch = function (uebrig) {
          // Nicht zwei Karten uebereinander, und nicht waehrend des Druckens.
          if (document.querySelector('.guide-werbung')) return;
          /* Nicht ueber das PDF-Popup legen. Seit dem 09.09.2026 oeffnet sich
             auf den Guide-Seiten beim Laden der PDF-Betrachter, und der hat
             eigene Einblendungen. Solange er offen ist (body.no-pinch), wartet
             die Seiten-Werbung und prueft alle 15 Sekunden erneut, hoechstens
             zwanzigmal. Danach gibt sie fuer diese Seite auf. */
          if (document.body.classList.contains('no-pinch')) {
            if (uebrig > 0) setTimeout(function () { versuch(uebrig - 1); }, 15000);
            return;
          }
          if (!darfErscheinen()) return;
          standSchreiben({ anzahl: standLesen().anzahl + 1, zuletzt: Date.now() });
          schonAufDieserSeite = true;

          var huelle = document.createElement('div');
          huelle.className = 'guide-werbung';
          huelle.appendChild(vorlage.content.cloneNode(true));
          document.body.appendChild(huelle);

          var schliessen = function () {
            huelle.classList.add('geht-zu');
            window.setTimeout(function () { huelle.remove(); }, 200);
            document.removeEventListener('keydown', beiTaste);
          };
          var beiTaste = function (e) {
            if (e.key === 'Escape') schliessen();
          };

          var knopf = huelle.querySelector('.guide-werbung__schliessen');
          if (knopf) {
            knopf.addEventListener('click', schliessen);
            knopf.focus();
          }
          // Klick daneben schliesst ebenfalls, Klick auf die Karte nicht.
          huelle.addEventListener('click', function (e) {
            if (e.target === huelle) schliessen();
          });
          document.addEventListener('keydown', beiTaste);
        };
        setTimeout(function () { versuch(20); }, verzoegerung);
      }
    );

    // ---- Oberflaechentexte je Sprache (11.09.2026, erweitert 13.10. und 25.10.2026) ----
    // Shopify setzt <html lang="xx"> auf den uebersetzten Seiten; daran haengt
    // die Auswahl. Deutsch ist der Rueckfall fuer alles Unbekannte. Polnisch
    // nutzt "rozdz.", weil die volle Form je nach Zahl dekliniert wird.
    var SPRACHE = String(document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
    var TEXTE = {
      en: {
        lesezeit: ' min read', kapitel: ' chapters', drucken: '🖨️ Save as PDF',
        inhalt: 'Contents', inhaltsverzeichnis: 'Table of contents', von: ' of ',
        zurueck: '↑ back to contents', stand: 'Version ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Promo code ' + code + prozent + ' is valid until ' + bis
            + ', afterwards ' + danach + ' (' + prozentDanach + ') applies again.';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Discount code ' + code + prozent + ' as of this printout. The current code is on ' + quelle + '.';
        }
      },
      es: {
        lesezeit: ' min de lectura', kapitel: ' capítulos', drucken: '🖨️ Guardar como PDF',
        inhalt: 'Contenido', inhaltsverzeichnis: 'Índice de contenidos', von: ' de ',
        zurueck: '↑ volver al índice', stand: 'Versión ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'El código promocional ' + code + prozent + ' es válido hasta el ' + bis
            + '; después vuelve a aplicarse ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Código de descuento ' + code + prozent + ' a fecha de esta impresión. El código vigente está en ' + quelle + '.';
        }
      },
      fr: {
        lesezeit: ' min de lecture', kapitel: ' chapitres', drucken: '🖨️ Enregistrer en PDF',
        inhalt: 'Sommaire', inhaltsverzeichnis: 'Table des matières', von: ' sur ',
        zurueck: '↑ retour au sommaire', stand: 'Version du ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Le code promo ' + code + prozent + ' est valable jusqu’au ' + bis
            + ', ensuite ' + danach + ' (' + prozentDanach + ') s’applique à nouveau.';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Code de réduction ' + code + prozent + ' à la date de cette impression. Le code en vigueur se trouve sur ' + quelle + '.';
        }
      },
      pt: {
        lesezeit: ' min de leitura', kapitel: ' capítulos', drucken: '🖨️ Guardar como PDF',
        inhalt: 'Conteúdo', inhaltsverzeichnis: 'Índice', von: ' de ',
        zurueck: '↑ voltar ao índice', stand: 'Versão ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'O código promocional ' + code + prozent + ' é válido até ' + bis
            + '; depois volta a aplicar-se ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Código de desconto ' + code + prozent + ' à data desta impressão. O código em vigor está em ' + quelle + '.';
        }
      },
      pl: {
        lesezeit: ' min czytania', kapitel: ' rozdz.', drucken: '🖨️ Zapisz jako PDF',
        inhalt: 'Spis treści', inhaltsverzeichnis: 'Spis treści', von: ' z ',
        zurueck: '↑ powrót do spisu treści', stand: 'Stan z ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Kod promocyjny ' + code + prozent + ' obowiązuje do ' + bis
            + ', potem znów obowiązuje ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Kod rabatowy ' + code + prozent + ', stan na dzień wydruku. Aktualny kod znajdziesz na ' + quelle + '.';
        }
      },
      it: {
        lesezeit: ' min di lettura', kapitel: ' capitoli', drucken: '🖨️ Salva come PDF',
        inhalt: 'Contenuti', inhaltsverzeichnis: 'Indice', von: ' di ',
        zurueck: '↑ torna all’indice', stand: 'Versione ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Il codice promo ' + code + prozent + ' è valido fino al ' + bis
            + ', poi torna valido ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Codice sconto ' + code + prozent + ' alla data di questa stampa. Il codice attuale è su ' + quelle + '.';
        }
      },
      tr: {
        lesezeit: ' dk okuma süresi', kapitel: ' bölüm', drucken: '🖨️ PDF olarak kaydet',
        inhalt: 'İçindekiler', inhaltsverzeichnis: 'İçindekiler', von: ' / ',
        zurueck: '↑ içindekilere dön', stand: 'Güncelleme: ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Kampanya kodu ' + code + prozent + ' ' + bis + ' tarihine kadar geçerli, '
            + 'sonrasında yeniden ' + danach + ' (' + prozentDanach + ') geçerli olur.';
        },
        rabatt: function (code, prozent, quelle) {
          return 'İndirim kodu ' + code + prozent + ', bu çıktının tarihindeki haliyle. Güncel kodu ' + quelle + ' adresinde bulursun.';
        }
      },
      ja: {
        lesezeit: ' 分で読めます', kapitel: ' 章', drucken: '🖨️ PDFとして保存',
        inhalt: '目次', inhaltsverzeichnis: '目次', von: ' / ',
        zurueck: '↑ 目次に戻る', stand: '更新日：',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'プロモコード ' + code + prozent + ' は ' + bis + ' まで有効です。その後は再び ' + danach + '（' + prozentDanach + '）が適用されます。';
        },
        rabatt: function (code, prozent, quelle) {
          return '割引コード ' + code + prozent + '（印刷時点）。最新のコードは ' + quelle + ' にあります。';
        }
      },
      ru: {
        lesezeit: ' мин чтения', kapitel: ' глав', drucken: '🖨️ Сохранить как PDF',
        inhalt: 'Содержание', inhaltsverzeichnis: 'Оглавление', von: ' из ',
        zurueck: '↑ к содержанию', stand: 'Версия от ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Промокод ' + code + prozent + ' действует до ' + bis + ', затем снова действует ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Код скидки ' + code + prozent + ' на момент печати. Актуальный код есть на ' + quelle + '.';
        }
      },
      uk: {
        lesezeit: ' хв читання', kapitel: ' розд.', drucken: '🖨️ Зберегти як PDF',
        inhalt: 'Зміст', inhaltsverzeichnis: 'Зміст', von: ' з ',
        zurueck: '↑ до змісту', stand: 'Версія від ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Промокод ' + code + prozent + ' діє до ' + bis + ', потім знову діє ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Код знижки ' + code + prozent + ' на момент друку. Актуальний код є на ' + quelle + '.';
        }
      },
      nl: {
        lesezeit: ' min leestijd', kapitel: ' hoofdstukken', drucken: '🖨️ Opslaan als PDF',
        inhalt: 'Inhoud', inhaltsverzeichnis: 'Inhoudsopgave', von: ' van ',
        zurueck: '↑ terug naar de inhoud', stand: 'Versie ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Actiecode ' + code + prozent + ' is geldig tot ' + bis + ', daarna geldt weer ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Kortingscode ' + code + prozent + ', stand bij het afdrukken. De actuele code staat op ' + quelle + '.';
        }
      },
      af: {
        lesezeit: ' min leestyd', kapitel: ' hoofstukke', drucken: '🖨️ Stoor as PDF',
        inhalt: 'Inhoud', inhaltsverzeichnis: 'Inhoudsopgawe', von: ' van ',
        zurueck: '↑ terug na die inhoud', stand: 'Weergawe ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Promosiekode ' + code + prozent + ' is geldig tot ' + bis + ', daarna geld ' + danach + ' (' + prozentDanach + ') weer.';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Afslagkode ' + code + prozent + ', soos met hierdie drukstuk. Die huidige kode is op ' + quelle + '.';
        }
      },
      el: {
        lesezeit: ' λεπτά ανάγνωσης', kapitel: ' κεφάλαια', drucken: '🖨️ Αποθήκευση ως PDF',
        inhalt: 'Περιεχόμενα', inhaltsverzeichnis: 'Πίνακας περιεχομένων', von: ' από ',
        zurueck: '↑ πίσω στα περιεχόμενα', stand: 'Έκδοση ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Ο κωδικός προσφοράς ' + code + prozent + ' ισχύει έως ' + bis + ', μετά ισχύει ξανά ο ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Κωδικός έκπτωσης ' + code + prozent + ', όπως κατά την εκτύπωση. Τον τρέχοντα κωδικό θα τον βρεις στο ' + quelle + '.';
        }
      },
      sq: {
        lesezeit: ' min lexim', kapitel: ' kapituj', drucken: '🖨️ Ruaje si PDF',
        inhalt: 'Përmbajtja', inhaltsverzeichnis: 'Pasqyra e lëndës', von: ' nga ',
        zurueck: '↑ kthehu te përmbajtja', stand: 'Versioni ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Kodi promocional ' + code + prozent + ' vlen deri më ' + bis + ', pastaj vlen sërish ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Kodi i zbritjes ' + code + prozent + ', sipas datës së printimit. Kodin aktual e gjen në ' + quelle + '.';
        }
      },
      hu: {
        lesezeit: ' perc olvasás', kapitel: ' fejezet', drucken: '🖨️ Mentés PDF-ként',
        inhalt: 'Tartalom', inhaltsverzeichnis: 'Tartalomjegyzék', von: ' / ',
        zurueck: '↑ vissza a tartalomhoz', stand: 'Állapot: ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'A(z) ' + code + prozent + ' promóciós kód ' + bis + '-ig érvényes, utána ismét a(z) ' + danach + ' (' + prozentDanach + ') érvényes.';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Kedvezménykód: ' + code + prozent + ', a nyomtatás időpontjában. Az aktuális kódot itt találod: ' + quelle + '.';
        }
      },
      ro: {
        lesezeit: ' min de citit', kapitel: ' capitole', drucken: '🖨️ Salvează ca PDF',
        inhalt: 'Cuprins', inhaltsverzeichnis: 'Cuprins', von: ' din ',
        zurueck: '↑ înapoi la cuprins', stand: 'Versiunea din ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Codul promoțional ' + code + prozent + ' este valabil până la ' + bis + ', apoi se aplică din nou ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Cod de reducere ' + code + prozent + ', valabil la data tipăririi. Codul actual îl găsești pe ' + quelle + '.';
        }
      },
      cs: {
        lesezeit: ' min čtení', kapitel: ' kap.', drucken: '🖨️ Uložit jako PDF',
        inhalt: 'Obsah', inhaltsverzeichnis: 'Obsah', von: ' z ',
        zurueck: '↑ zpět na obsah', stand: 'Stav k ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Promo kód ' + code + prozent + ' platí do ' + bis + ', potom opět platí ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Slevový kód ' + code + prozent + ', stav k datu tisku. Aktuální kód najdeš na ' + quelle + '.';
        }
      },
      hr: {
        lesezeit: ' min čitanja', kapitel: ' pogl.', drucken: '🖨️ Spremi kao PDF',
        inhalt: 'Sadržaj', inhaltsverzeichnis: 'Sadržaj', von: ' od ',
        zurueck: '↑ natrag na sadržaj', stand: 'Stanje: ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Promotivni kod ' + code + prozent + ' vrijedi do ' + bis + ', a nakon toga ponovno vrijedi ' + danach + ' (' + prozentDanach + ').';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Kod za popust ' + code + prozent + ', stanje u trenutku ispisa. Aktualni kod nalaziš na ' + quelle + '.';
        }
      },
      sv: {
        lesezeit: ' min läsning', kapitel: ' kapitel', drucken: '🖨️ Spara som PDF',
        inhalt: 'Innehåll', inhaltsverzeichnis: 'Innehållsförteckning', von: ' av ',
        zurueck: '↑ tillbaka till innehållet', stand: 'Version ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Kampanjkoden ' + code + prozent + ' gäller till ' + bis + ', därefter gäller ' + danach + ' (' + prozentDanach + ') igen.';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Rabattkod ' + code + prozent + ', enligt utskriftsdatum. Den aktuella koden finns på ' + quelle + '.';
        }
      },
      da: {
        lesezeit: ' min. læsetid', kapitel: ' kapitler', drucken: '🖨️ Gem som PDF',
        inhalt: 'Indhold', inhaltsverzeichnis: 'Indholdsfortegnelse', von: ' af ',
        zurueck: '↑ tilbage til indholdet', stand: 'Version ',
        aktion: function (code, prozent, bis, danach, prozentDanach) {
          return 'Kampagnekoden ' + code + prozent + ' gælder til ' + bis + ', derefter gælder ' + danach + ' (' + prozentDanach + ') igen.';
        },
        rabatt: function (code, prozent, quelle) {
          return 'Rabatkode ' + code + prozent + ', pr. udskriftsdatoen. Den aktuelle kode står på ' + quelle + '.';
        }
      }
    };
    var T = TEXTE[SPRACHE] || {
      lesezeit: ' Minuten Lesezeit', kapitel: ' Kapitel', drucken: '🖨️ Als PDF speichern',
      inhalt: 'Inhalt', inhaltsverzeichnis: 'Inhaltsverzeichnis', von: ' von ',
      zurueck: '↑ zurück zum Inhalt', stand: 'Stand ',
      aktion: function (code, prozent, bis, danach, prozentDanach) {
        return 'Aktionscode ' + code + prozent + ' gilt bis ' + bis
          + ', danach wieder ' + danach + ' (' + prozentDanach + ').';
      },
      rabatt: function (code, prozent, quelle) {
        return 'Rabattcode ' + code + prozent + ', Stand des Ausdrucks. Der jeweils gültige Code steht auf ' + quelle + '.';
      }
    };

    // ---- Lesezeit aus dem tatsaechlichen Text, nicht aus dem HTML ----
    var woerter = (inhalt.textContent || '').trim().split(/\s+/).length;
    // Japanisch trennt Woerter nicht mit Leerzeichen: dort ueber die Zeichenzahl
    // rechnen (etwa 500 Zeichen pro Minute, 25.10.2026).
    if (SPRACHE === 'ja') {
      woerter = Math.round((inhalt.textContent || '').replace(/\s+/g, '').length / 500 * WOERTER_PRO_MINUTE);
    }
    var minuten = Math.max(1, Math.round(woerter / WOERTER_PRO_MINUTE));

    // ---- Kopfzeile ----
    var kopf = document.createElement('p');
    kopf.className = 'guide-meta';
    kopf.innerHTML =
      '<span>⏱️ ' + minuten + T.lesezeit + '</span>' +
      '<span>📑 ' + kapitel.length + T.kapitel + '</span>';

    // ---- Drucken ----
    // Angaben kommen aus sections/main-page.liquid. Der Stand ist das
    // Aenderungsdatum der Seite und pflegt sich damit selbst; eine eigene
    // Versionsnummer im Seiteninhalt (data-guide-version) geht vor.
    var titel = inhalt.getAttribute('data-guide-titel') || document.title;
    var quelle = inhalt.getAttribute('data-guide-quelle') || location.host + location.pathname;
    // Leer bleibt leer: Bei einer unveroeffentlichten Seite liefert Shopify
    // kein published_at. Ohne diese Pruefung stand im Ausdruck "Stand" ohne
    // Datum dahinter.
    var eigene = inhalt.querySelector('[data-guide-version]');
    var datum = inhalt.getAttribute('data-guide-stand');
    var stand = eigene
      ? eigene.getAttribute('data-guide-version')
      : (datum ? T.stand + datum : '');

    var drucken = document.createElement('button');
    drucken.type = 'button';
    drucken.className = 'guide-drucken';
    drucken.innerHTML = T.drucken;
    drucken.addEventListener('click', function () {
      alleBilderLaden(function () { window.print(); });
    });

    /* Der Browser druckt seinen eigenen Seitenkopf aus document.title — das ist
       der SEO-Titel der Seite („Veganes Protein: Bedarf, Quellen und was
       wirklich taugt | NVSINO“). Im Ausdruck soll dort der Name des Guides
       stehen; er landet damit auch im Dateinamen des gespeicherten PDFs.

       Danach wird der alte Titel wiederhergestellt, damit Lesezeichen und
       geteilte Links unveraendert bleiben. */
    var titelVorher = document.title;
    window.addEventListener('beforeprint', function () {
      document.title = titel;
    });
    window.addEventListener('afterprint', function () {
      document.title = titelVorher;
    });
    kopf.appendChild(drucken);

    // Nur auf Papier sichtbar (siehe nvsino-modern.css).
    //
    // Der Titelblock steht einmal am Anfang, nicht als wiederholte Kopfzeile:
    // Ein `position: fixed` am oberen Rand legte sich im ersten Versuch ueber
    // den Text jeder Folgeseite. Den Namen des Guides nennt ohnehin auch die
    // Kopfzeile, die der Browser selbst druckt.
    var druckkopf = document.createElement('div');
    druckkopf.className = 'guide-druckkopf';
    druckkopf.innerHTML = '<strong>NVSINO</strong> · ' + quelle
      + (stand ? ' · ' + stand : '');

    // Rabatthinweis, nur im Ausdruck und nur wenn der Guide einen Code nennt.
    //
    // Auf der Webseite ist der Rabatt immer aktuell — er kommt aus den
    // Theme-Einstellungen. Ein ausgedrucktes PDF friert ihn ein: Wer waehrend
    // einer Aktion druckt, haelt spaeter einen Code in der Hand, der nicht mehr
    // gilt. Deshalb steht im Ausdruck dabei, bis wann er gilt und was danach
    // greift.
    var code = inhalt.getAttribute('data-guide-code');
    if (code && inhalt.textContent.indexOf(code) !== -1) {
      var prozent = inhalt.getAttribute('data-guide-prozent') || '';
      var bis = inhalt.getAttribute('data-guide-aktion-bis');
      var hinweis;
      var prozentText = prozent ? ' (' + prozent + ')' : '';
      if (bis) {
        hinweis = T.aktion(code, prozentText, bis,
          inhalt.getAttribute('data-guide-code-danach') || '',
          inhalt.getAttribute('data-guide-prozent-danach') || '');
      } else {
        hinweis = T.rabatt(code, prozentText, quelle);
      }
      var zeile = document.createElement('div');
      zeile.className = 'guide-druckhinweis';
      zeile.textContent = hinweis;
      druckkopf.appendChild(zeile);
    }

    // Abschluss am Dokumentende.
    //
    // Eine auf jeder Seite wiederholte Fusszeile waere schoener, ist im Browser
    // aber nicht verlaesslich zu bauen: `position: fixed` landet beim Drucken
    // im bedruckbaren Bereich statt im Seitenrand und legt sich dann auf den
    // Text — in zwei Anlaeufen einmal oben, einmal mitten auf der Seite.
    // Zuverlaessig ginge das nur mit <thead>/<tfoot> um den gesamten Inhalt,
    // und dafuer muesste jeder Guide umgebaut werden.
    //
    // Die Herkunft steht deshalb im Titelblock auf Seite 1 und hier am Ende.
    // Auf den Seiten dazwischen nennt sie die Fusszeile, die der Browser
    // selbst druckt — dort stehen Adresse, Datum und Seitenzahl.
    var druckfuss = document.createElement('div');
    druckfuss.className = 'guide-druckfuss';
    druckfuss.innerHTML = '<strong>' + titel + '</strong><br>' + quelle
      + (stand ? ' · ' + stand : '');

    inhalt.insertBefore(druckkopf, inhalt.firstChild);
    inhalt.appendChild(druckfuss);

    // ---- Inhaltsverzeichnis ----
    var box = document.createElement('nav');
    box.className = 'guide-inhalt';
    box.setAttribute('aria-label', T.inhaltsverzeichnis);
    /* Manche Guides nummerieren ihre Kapitel selbst — der Einkaufsguide von
       „1. Gemuese“ bis „15. Weitere nuetzliche Produkte“, der Naehrstoff-Guide
       seine Supplemente. Dort stand dann „1 von 18  1. Gemuese“ nebeneinander,
       und die beiden Zahlen widersprachen sich sogar, weil der Zaehler auch
       Anhaenge wie das Ernaehrungsteam mitzaehlt.

       In dem Fall zaehlt das Theme nicht mit: Die Nummer des Autors ist die
       verbindliche. Entweder alle Ueberschriften bekommen einen Zaehler oder
       keine — eine gemischte Zaehlung waere schlechter als beides.

       Eine einzige nummerierte Ueberschrift genuegt dafuer. Im Aktivismus-Guide
       heisst das dritte h2 „Kapitel 1 — Das Grundproblem“; daneben ein
       „3 von 13“ zu setzen, hilft niemandem.

       Erkannt werden „1.“ und „1)“. Kuechenhelfer und Allergie-Guide
       nummerieren in der Quelle mit Klammer; ohne das zweite Muster haetten
       beide Fassungen ihre Schreibweise aendern muessen, nur damit das Theme
       nicht doppelt zaehlt. */
    var zaehlen = !kapitel.some(function (h) {
      return /^\s*(\d+[.)]|Kapitel\s+\d+|Chapter\s+\d+)/.test(h.textContent);
    });

    /* Nummeriert der Autor selbst, zaehlt auch das Verzeichnis nicht mit —
       sonst steht dort „1. 1. Gemuese“. */
    var liste = '<p class="guide-inhalt__titel">' + T.inhalt + '</p><ol'
              + (zaehlen ? '' : ' class="guide-inhalt__liste--eigene-nummern"') + '>';
    kapitel.forEach(function (h, i) {
      var titel = h.textContent.trim();
      liste += '<li><a href="#' + h.id + '">' + titel + '</a></li>';
      if (!zaehlen) return;
      // Kapitelnummer in die Ueberschrift
      var nr = document.createElement('span');
      nr.className = 'guide-kapitelnr';
      nr.textContent = (i + 1) + T.von + kapitel.length;
      h.insertBefore(nr, h.firstChild);
    });
    liste += '</ol>';
    box.innerHTML = liste;

    // Vor dem ersten Kapitel einhaengen, aber nach der Einleitung
    kapitel[0].parentNode.insertBefore(box, kapitel[0]);
    box.parentNode.insertBefore(kopf, box);

    // ---- Zurueck-zum-Inhalt nach jedem Kapitel ----
    kapitel.forEach(function (h, i) {
      if (i === 0) return;
      var zurueck = document.createElement('p');
      zurueck.className = 'guide-zurueck';
      zurueck.innerHTML = '<a href="#guide-inhalt-anker">' + T.zurueck + '</a>';
      h.parentNode.insertBefore(zurueck, h);
    });
    box.id = 'guide-inhalt-anker';

    /* ---- Anmoderationen an ihre Liste binden ----
       Ein kurzer Satz wie „Eisenreiche Fruehstuecksflocken — einfach ins
       Fruehstueck mischen:“ soll im Ausdruck nicht allein am Seitenende
       zurueckbleiben, waehrend die Aufzaehlung darunter umbricht.

       Nur kurze Absaetze: Haelt man auch lange Absaetze an ihrer Liste fest,
       wandern beide gemeinsam und reissen ein groesseres Loch, als sie
       schliessen. 220 Zeichen sind etwa zwei Zeilen. */
    Array.prototype.forEach.call(inhalt.querySelectorAll('p'), function (absatz) {
      var naechstes = absatz.nextElementSibling;
      if (!naechstes) return;
      var tag = naechstes.tagName;
      /* Auch Bildgruppen und Abbildungen zaehlen. Im Protein-Guide steht
         „… hier eine Auflistung besonders proteinreicher Gemuesesorten:“ vor
         einem <div class="guide-bilder">, nicht vor der Liste. Die Regel griff
         deshalb nicht, die Figur passte nicht mehr ans Seitenende und nahm die
         Liste mit — zurueck blieb eine zu 73 % leere Seite. */
      var passt = tag === 'UL' || tag === 'OL' || tag === 'FIGURE'
        || (tag === 'DIV' && /guide-bilder/.test(naechstes.className));
      if (!passt) return;
      if ((absatz.textContent || '').trim().length > 220) return;
      absatz.classList.add('guide-anmoderation');
    });

    // ---- Kurze Adressen fuer den Ausdruck ----
    // Nur bei fremden Zielen: Bei eigenen Seiten steht die Domain schon in der
    // Fusszeile. Das Druck-CSS liest data-druckziel; ohne JavaScript bleibt die
    // Adresse im Ausdruck einfach weg.
    Array.prototype.forEach.call(
      inhalt.querySelectorAll('a[href^="http"]'),
      function (a) {
        if (a.hostname === location.hostname || /nvsino\.com$/.test(a.hostname)) return;
        var kurz = kurzeAdresse(a.href);
        if (!kurz) return;
        if (adresseStehtSchonImText(a, kurz)) return;
        a.setAttribute('data-druckziel', kurz);
      }
    );

    // ---- Fortschrittsbalken ----
    var balken = document.createElement('div');
    balken.className = 'guide-fortschritt';
    balken.innerHTML = '<div class="guide-fortschritt__fuellung"></div>';
    document.body.appendChild(balken);
    var fuellung = balken.firstChild;

    var laeuft = false;
    function messen() {
      var oben = inhalt.offsetTop;
      var hoehe = inhalt.offsetHeight - window.innerHeight;
      var gelesen = window.pageYOffset - oben;
      var anteil = hoehe > 0 ? gelesen / hoehe : 0;
      anteil = Math.min(1, Math.max(0, anteil));
      fuellung.style.width = (anteil * 100).toFixed(1) + '%';
      balken.classList.toggle('guide-fortschritt--sichtbar', anteil > 0.01 && anteil < 0.995);
      laeuft = false;
    }
    window.addEventListener('scroll', function () {
      if (!laeuft) { laeuft = true; window.requestAnimationFrame(messen); }
    }, { passive: true });
    window.addEventListener('resize', messen, { passive: true });
    messen();
  });
})();
